export default "__VITE_ASSET__CzUT_5Lu__"